import Component from './Header.vue';

export default Component;
